import React from "react";
import { Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import Modal from "@components/modal";

interface UnsavedChangesModalProps {
  isOpen?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UnsavedChangesModal = ({ isOpen, onClose, onConfirm }: UnsavedChangesModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      typeState="confirm"
      show={isOpen}
      title={t("programming-structures.modals.unsaved-changes.title")}
      textButtonPrincipal={t("generals.confirm")}
      textButtonSecondary={t("generals.cancel")}
      colorButtonPrincipal="danger"
      onClose={onClose}
      onClickPrincipal={onConfirm}
      onClickSecondary={onClose}
    >
      <Text>{t("programming-structures.modals.unsaved-changes.description")}</Text>
    </Modal>
  );
};

export default UnsavedChangesModal;
